import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, booting } = useAuth();
    const location = useLocation();
    if (booting) {
        return (
            <div className="min-h-[50vh] flex items-center justify-center text-sm" style={{ color: "#525252" }}>
                Loading…
            </div>
        );
    }
    if (!user || !user.id) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
}
